import React, { Component } from "react";
import _ from "lodash";
import { withRouter } from "react-router-dom";
import DrawerScrubber from "./components/drawer-scrubber";
import VerticalCenter from "./components/vertical-center";
import Items from "./components/drawer-items-perf";
import GlobalMenuIcon from "./components/global-menu-icon";
import GlobalMapIcon from "./components/global-map-icon";
import { inverseScale } from "./scale";
import { connect } from "react-redux";
import {
  startSFXForScroll,
  stopSFXForScroll,
  setSpeed,
  setMaxSpeed,
} from "./drawer-sfx";
import { processPlaylistsState } from "./util/stateProcessing";
import { setCurrentTrack } from "./currentDate";
import { resetMetadata } from "./actions/metas";
import SplashScreen from "./splash-screen";

const onDelta = (delta) => {
  setSpeed(delta);
};

/* must match drawer scss */
const topBarHeight = 106;
const itemHeight = 60;

function measureWidth() {
  return inverseScale() * window.innerWidth;
}
function measureHeight() {
  return inverseScale() * window.innerHeight - topBarHeight;
}
function measureFullHeight() {
  return inverseScale() * window.innerHeight;
}

class TopBar extends React.Component {
  render() {
    return (
      <div className="top-bar playlists">
        <div className="playlists-title">PLAYLISTS</div>
      </div>
    );
  }
}

class Drawer extends React.Component {
  setScroll(amt) {
    this.refs.items.setScroll(amt);
  }
  render() {
    let items = (this.props.items || []).filter(item => item && (item.id || item.playlistId));
    console.log("[playlists-drawer] Drawer props.items:", this.props.items?.length, "after id/playlistId filter:", items.length, items.map(i => ({ id: i.id, playlistId: i.playlistId, type: i.type, title: i.title })));
    return (
      <div className="box">
        <Items ref="items" {...this.props} items={items} />
      </div>
    );
  }
}

let pos = 0;
let pixelPos = 0;
let prevPixelPos = 0;

let scrollInterval = null;

const didStopMoving = () => {
  if (!scrollInterval) return;
  clearInterval(scrollInterval);
  scrollInterval = null;
  stopSFXForScroll();
};

let stopMovingTimeout = null;
const motionIntervalLength = (25 * 0.5) | 0;
const moveEndTimeout =
  50 >= motionIntervalLength ? motionIntervalLength * 0.8 : 50;

const updateMotion = () => {
  onDelta(Math.floor(pixelPos));
  const EPS = 1.0;
  const delta = Math.abs(pixelPos - prevPixelPos);
  if (delta <= EPS) {
    let curr = pixelPos;
    if (stopMovingTimeout) clearTimeout(stopMovingTimeout);
    stopMovingTimeout = setTimeout(() => {
      stopMovingTimeout = null;
      if (Math.abs(pixelPos - curr) <= EPS) didStopMoving();
    }, moveEndTimeout);
  }
  prevPixelPos = pixelPos;
};

class PlaylistsDrawerContainer extends Component {
  constructor(props) {
    super(props);

    let position = 0;

    if (props.location && props.location.search) {
      let re = /position=(\d+(\.\d+)?)/;
      let m = props.location.search.match(re);
      if (m) {
        position = parseFloat(m[1]);
      }
    }

    this.state = {
      position,
      width: 0,
      height: 0,
    };

    this.updateScrollPosition = this.updateScrollPosition.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onScrub = this.onScrub.bind(this);
    this.onWindowFocus = this.onWindowFocus.bind(this);
    this.viewMore = this.viewMore.bind(this);
    this.startedScrubbing = this.startedScrubbing.bind(this);
    this.endedScrubbing = this.endedScrubbing.bind(this);

    this._didScroll = this._didScroll.bind(this);
    this._didScroll = _.throttle(this._didScroll, 100);
  }

  startedScrubbing() {
    setMaxSpeed(0);
  }
  endedScrubbing() {
    setMaxSpeed(50);
  }
  shouldComponentUpdate(newprops, newstate) {
    return true;
  }
  updateScrollPosition(pct) {
    if (pct === this.state.position) return;
    if (_.isNaN(pct)) return;
    pct = Math.max(0, Math.min(100, pct));
    pos = pct;
    pixelPos = this._getPixelPosition(pos);
    onDelta(pixelPos);
    this._didScroll(pct);
  }
  _didScroll(pct) {
    setCurrentTrack(null);
    this.setState({ position: pct }, this.updatePositionUrl);
  }
  updatePositionUrl() {
    let { position } = this.state;
    this.props.history.replace(`/playlists?position=${position}`);
  }
  onResize() {
    let width = measureWidth();
    let height = measureHeight();
    this.setState({ width, height });
  }
  onWindowFocus() {
    _.delay(this.onResize, 30);
  }
  componentDidMount() {
    window.addEventListener("resize", this.onResize, false);
    window.addEventListener("focus", this.onWindowFocus, false);
    this.onResize();
    this.onScrub(this.state.position);
  }
  componentWillMount() {
    resetMetadata();
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.onResize, false);
    window.removeEventListener("focus", this.onWindowFocus, false);
    didStopMoving();
  }
  viewMore(item) {
    let { id, isPlaylist, playlistId } = item;
    if (isPlaylist) {
      this.props.history.push(`/playlist?id=${id || playlistId}`);
    }
  }
  onScrub(amt) {
    this.refs.drawer.setScroll(amt);
    this.updateScrollPosition(amt);
  }
  _getPixelPosition(position = this.state.position, items = this.props.items) {
    if (!items || items.length === 0 || !this.state.height) return 0;
    let screensWorth = this.state.height / itemHeight;
    let count = Math.max(1, items.length - screensWorth);
    return count * (position / 100) * itemHeight;
  }
  render() {
    let pct = this.state.position;
    return (
      <div id="drawer" className="playlists-drawer">
        <TopBar />
        <Drawer
          ref="drawer"
          onScroll={this.updateScrollPosition}
          pct={pct}
          viewMore={this.viewMore}
          measureWidth={measureWidth}
          measureHeight={measureHeight}
          items={this.props.items}
          dispatch={this.props.dispatch}
        />
        <div className="shader-wrapper top">
          <div className="shader top"></div>
        </div>
        <VerticalCenter className="scrubber-container">
          <DrawerScrubber
            onScroll={this.onScrub}
            pct={pct}
            moveStart={this.startedScrubbing}
            moveEnd={this.endedScrubbing}
          />
        </VerticalCenter>
        <VerticalCenter className="years-container" style={{ display: "table" }} />
        <GlobalMenuIcon />
        <GlobalMapIcon />
      </div>
    );
  }
}

const mapStateToProps = function (state) {
  if (state.status !== "drawerLoaded") {
    return { loaded: false };
  }
  const processedState = processPlaylistsState(state);
  const { items } = processedState;
  console.log("[playlists-drawer] items:", items.map(i => ({ id: i.id, playlistId: i.playlistId, type: i.type, isPlaylist: i.isPlaylist, title: i.title })));
  return { loaded: true, tracks: state.tracks, items: items || [] };
};

const PlaylistsDrawerWrapper = (props) => {
  if (!props.loaded)
    return (
      <div id="drawer" className="playlists-drawer">
        <TopBar />
        <SplashScreen loadState={100} />
      </div>
    );
  return <PlaylistsDrawerContainer {...props} />;
};

export default withRouter(connect(mapStateToProps)(PlaylistsDrawerWrapper));
